import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { LearningRoutes, pathTo } from '../../../Routes';

import CareGuideWrapper from '../../../layouts/components/CareGuideWrapper';
import DocumentHead from '../../../elements/components/DocumentHead';
import Loading from '../../../elements/components/Loading';
import CareGuideDisabled from '../../careGuides/components/CareGuideDisabled';

function LearningLayout({
  isCareGuideLoading,
  careGuideId,
  isCareGuideActive,
  careGuide,
  partnershipId,
  setActiveAccess,
  ...props
}) {
  useEffect(() => {
    if (isCareGuideActive) {
      if (careGuide?.partnership) {
        setActiveAccess({
          access_role_admin_in_care_guide:
            careGuide.partnership.access_role_admin_in_care_guide,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCareGuideActive, careGuide, partnershipId, careGuideId]);

  if (isCareGuideLoading) {
    return (
      <Translation>
        {(t) => (
          <CareGuideWrapper>
            <DocumentHead title={t('learnings_route_list')} />
            <Loading />
          </CareGuideWrapper>
        )}
      </Translation>
    );
  }
  if (isCareGuideActive === null) {
    return <Redirect to={pathTo('HomeScreen')} />;
  }
  if (!isCareGuideActive) {
    return (
      <Translation>
        {(t) => (
          <CareGuideWrapper>
            <DocumentHead title={t('learnings_route_list')} />
            <CareGuideDisabled careGuideId={careGuideId} />
          </CareGuideWrapper>
        )}
      </Translation>
    );
  }

  return (
    <Translation>
      {(t) => (
        <CareGuideWrapper>
          <DocumentHead title={t('learnings_route_list')} />
          <LearningRoutes />
        </CareGuideWrapper>
      )}
    </Translation>
  );
}

export default LearningLayout;
